module.exports = (a, b, options) => {
    if (a && a.includes(b)) { return options.fn(this); }
    return options.inverse(this);
};
